<template>
  <div class="p-4">
    <AgencySubscriptionForm @close="goBack" @created="onCreated" />
  </div>
</template>

<script>
import AgencySubscriptionForm from './AgencySubscriptionForm.vue';
export default {
  name: 'AgencySubscriptionCreate',
  components: { AgencySubscriptionForm },
  methods: {
    goBack() {
      this.$router.push({ name: 'agency.business-subscriptions' });
    },
    onCreated() {
      this.$router.push({ name: 'agency.business-subscriptions' });
    }
  }
};
</script>

